export class Question {
	constructor(questionId: string, category: string, answers: string) {
		this.questionId = questionId;
		this.category = category;
		this.answers = answers	
	}

	questionId: string;
	answers: string;
	category: string;
}